<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="字典名称">
            <el-input
              v-model="queryParams.dictName"
              placeholder="请输入字典名称进行查询"
              class="form-item-width"
              clearable
            ></el-input>
          </el-form-item>
      
          <div class="btn-boxs">
            <div>
              <el-button icon="el-icon-plus" type="primary" @click="handledictTypeAdd">新 增</el-button>
              <el-button
                :disabled="!multipleSelection.length"
                icon="el-icon-delete"
                type="danger"
                @click="batchDelete"
              >批量删除</el-button>
            </div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        border
        row-key="deptId"
        default-expand-all
        :tree-props="{children: 'children'}"
        highlight-current-row
        max-height="447"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize:'14px'}"
        @selection-change="handleSelectionChange"
      >
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column
          align="center"
          v-for="tab in tableTitle"
          :key="tab.code"
          :label="tab.name"
          show-overflow-tooltip
          :width="tab.width"
        >
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span
              v-if="tab.code === 'status'"
              :style="scope.row.status === '0' ? { color: 'green'  } : { color: 'red'  }"
            >{{ scope.row.status === '0' ? '正常' : '停用' }}</span>
            <span
              style="color:#337ab7;cursor: pointer;"
              v-else-if="tab.code === 'dictType'"
              @click="addDictData(scope.row)"
            >{{ scope.row.dictType}}</span>
            <!-- 其他列的常规展示 -->
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button
              style="color:red"
              type="text"
              @click="deleteData(scope.row)"
              class="update-btn"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination
          background
          :total="pageParams.total"
          :page="pageParams.pageNum"
          :limit="pageParams.pageSize"
          @pagination="onChangePages"
        />
      </div>
    </div>
    <!-- 添加 修改角色 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="deptFormVisible"
      width="30%"
      @close="handleDialogClose"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="字典名称" prop="dictName">
          <el-input v-model="form.dictName" autocomplete="off" placeholder="请输入字典名称"></el-input>
        </el-form-item>
        <el-form-item label="字典类型" prop="dictType">
          <el-input v-model="form.dictType" autocomplete="off" placeholder="请输入字典类型"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择状态">
            <el-option label="正常" value="0"></el-option>
            <el-option label="停用" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          :icon="dialogTitle === '新增' ? 'el-icon-plus':'el-icon-edit'"
          type="primary"
          @click="submitForm('form')"
        >{{dialogTitle === '新增'? '立即添加': '立即修改'}}</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('form')">重 置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getDictTypeList, dictTypeAdd, dictTypeById,updeteDictType,deleteDictType} from "@/api/admin-service/dict.js";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      form: {
        dictName: "", //字典名称
        dictType: "", //字典类型
        status: ""
      },
      rules: {
        dictName: [
          { required: true, message: "请填写字典名称", trigger: "blur" }
        ],
        dictType: [
          { required: true, message: "请填写字典类型", trigger: "blur" }
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      deptFormVisible: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "字典名称", code: "dictName", width: "" },
        { name: "字典类型", code: "dictType", width: "" },
        { name: "状态", code: "status", width: "" }
      ],
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        orderByColumn: "",
        isAsc: "",
        dictName: "",
        dictType: "",
        status: "",
        orderBy: ""
      },
      multipleSelection: []
    };
  },
  mounted() {
    this.onGetDataList();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDelete() {
      this.$confirm(`提示，确定要删除选中的这些数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          // 使用 map() 来获取 dictId 组成的数组
          const ids = (this.multipleSelection || []).map(item => item.dictId);
          deleteDictType({ ids }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //跳转页面
    addDictData(row) {
      this.$router.push({
        name: "dictData",
        query: row // 假设 row.id 是你要传递的参数
      });
    },

    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === "新增") {
            const formData = { ...this.form };
            delete formData.dictId; // 清除 userId
            dictTypeAdd(formData).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.deptFormVisible = false;
                this.onGetDataList();
              }
            });
          } else {
            updeteDictType({
              ...this.form,
              dictId: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.deptFormVisible = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          deleteDictType({ ids: [row.dictId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
              this.form.menuIds = [];
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改";
      this.deptFormVisible = true;
      this.updateId = row.dictId;
      dictTypeById({ id: row.dictId }).then(res => {
        Object.assign(this.form, res?.data);
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getDictTypeList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          this.tableData = records;
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handledictTypeAdd() {
      this.dialogTitle = "新增";
      this.deptFormVisible = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
            this.pageParams.pageNum = 1
      this.pageParams.pageSize = 10
      this.queryParams.dictName = "";
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}
.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}
.margin-top {
  margin-top: -15px;
}
</style>